export default "__VITE_ASSET__CqDmVys1__"